import React, { useState } from "react";
import moment from "moment";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CancelSubModal from "./CancelSubModel";

const SubscriptionsModal = ({ getAllWhiteLabelClients, setOpen, open }) => {
  const [openCancelSubModal, setOpenCancelSubModal] = useState({
    open: false,
    data: null,
  });

  const handleClose = () => {
    setOpen({ open: false, data: null });
  };

  const isStripePaidUser =
    open?.data?.white_label_plans?.subscriptions?.base?.id?.startsWith("sub_");

  return (
    <>
      <Dialog open={open.open} onClose={handleClose} maxWidth="sm">
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Subscription Details
          </Typography>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: 2,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {open?.data?.white_label_plans?.subscriptions?.base?.cancelled &&
              open?.data?.white_label_plans?.planStatus === "active" ? (
                <Alert severity="warning" variant="outlined">
                  The subscription has been cancelled but will remain active
                  until{" "}
                  <strong>
                    {moment(
                      open.data.white_label_plans.subscriptions.base.endDate
                    ).format("DD-MM-YYYY")}
                  </strong>
                  .
                </Alert>
              ) : open?.data?.white_label_plans?.subscriptions?.base
                  ?.cancelled &&
                open?.data?.white_label_plans?.planStatus !== "active" ? (
                <Alert variant="outlined" severity="error">
                  Subscription has been expired.
                </Alert>
              ) : (
                ""
              )}
            </Grid>
            <Grid item xs={12}>
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  Package Name
                </Typography>
              </Box>
              <Box>
                <Typography variant="body1" fontWeight="medium">
                  {open?.data?.white_label_plans?.subscriptions?.base
                    ?.packageName || "N/A"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  Start Date
                </Typography>
              </Box>
              <Box>
                <Typography variant="body1" fontWeight="medium">
                  {open?.data?.white_label_plans?.subscriptions?.base?.startDate
                    ? moment(
                        open.data.white_label_plans.subscriptions.base.startDate
                      ).format("DD-MM-YYYY")
                    : "N/A"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  End Date
                </Typography>
              </Box>
              <Box>
                <Typography variant="body1" fontWeight="medium">
                  {open?.data?.white_label_plans?.subscriptions?.base?.endDate
                    ? moment(
                        open.data.white_label_plans.subscriptions.base.endDate
                      ).format("DD-MM-YYYY")
                    : "N/A"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                  width: "100%",
                }}
              >
                <Button
                  variant="contained"
                  disabled={
                    open?.data?.white_label_plans?.subscriptions?.base
                      ?.cancelled
                  }
                  sx={{
                    width: "100%",
                    flexGrow: 1,
                    textTransform: "none",
                  }}
                  onClick={() =>
                    setOpenCancelSubModal({ open: true, data: open?.data })
                  }
                >
                  Cancel Subscription
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <CancelSubModal
        isStripePaidUser={isStripePaidUser}
        getAllWhiteLabelClients={getAllWhiteLabelClients}
        closeSubscriptionDetailModal={handleClose}
        setOpen={setOpenCancelSubModal}
        open={openCancelSubModal}
      />
    </>
  );
};

export default SubscriptionsModal;
